import React from 'react';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { MenuItem, MenuList, ClickAwayListener, Chip } from '@material-ui/core';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import useCurrentSessionData from 'hooks/use-current-session-data';
import useLogOut from 'hooks/use-log-out';
import {
    MenuButton,
    PopperStyled,
    GrowStyled,
    PaperStyled,
    MenuListHeader,
} from './index.styled';

const UserMenu = () => {
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef<HTMLButtonElement>(null);

    const handleOnLogOut = useLogOut();
    const { firstName, lastName, permissionRoleName } = useCurrentSessionData();

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event: React.MouseEvent<EventTarget>) => {
        if (
            anchorRef.current &&
            anchorRef.current.contains(event.target as HTMLElement)
        ) {
            return;
        }

        setOpen(false);
    };

    function handleListKeyDown(event: React.KeyboardEvent) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    }

    /** Return focus to the button when we transitioned from !open -> open */
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current && !open) {
            anchorRef.current!.focus();
        }

        prevOpen.current = open;
    }, [open]);
    return (
        <div>
            <MenuButton
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
            >
                <AccountCircleIcon />
            </MenuButton>
            <PopperStyled
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
            >
                {({ TransitionProps, placement }) => (
                    <GrowStyled {...TransitionProps} placement={placement}>
                        <PaperStyled>
                            <ClickAwayListener onClickAway={handleClose}>
                                <>
                                    <MenuListHeader>
                                        <AccountBoxIcon /> {firstName}{' '}
                                        {lastName}{' '}
                                        <Chip
                                            label={
                                                permissionRoleName ||
                                                'Unauthorized'
                                            }
                                            size="small"
                                        />
                                    </MenuListHeader>
                                    <MenuList
                                        autoFocusItem={open}
                                        id="menu-list-grow"
                                        onKeyDown={handleListKeyDown}
                                    >
                                        <MenuItem
                                            onClick={() => handleOnLogOut()}
                                        >
                                            Logout
                                        </MenuItem>
                                    </MenuList>
                                </>
                            </ClickAwayListener>
                        </PaperStyled>
                    </GrowStyled>
                )}
            </PopperStyled>
        </div>
    );
};

export default UserMenu;
